import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import intersect from "@alpinejs/intersect";
import persist from "@alpinejs/persist";
import Clipboard from "@ryangjchandler/alpine-clipboard";
import grow from "alpinejs-textarea-grow";
import "./Ajaxify";
import "./CookieStorage";
import "./Popup";
import "./Debug";
import "./Fetch";
import "./SideMenu";
import "./LinkIcon";
import dialog from "./Dialog";
import disclosure from "./Disclosure";
import "./Interval";
import "./EmbededVideo";
import "./Magics";
import "./Voyeur";

Alpine.plugin([focus, collapse, persist, intersect, Clipboard, dialog, disclosure, grow]);

window.Alpine = Alpine;

export default Alpine;
